module.exports = __webpack_public_path__ + "static/media/WhenYouWishUponaLantern.f3535c58.jpg";